import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-617a0ddc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"margin-bottom":"12px"}
}
const _hoisted_2 = { style: {"margin-top":"24px"} }
const _hoisted_3 = { style: {"margin-bottom":"24px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"width":"4px"} }, null, -1))
const _hoisted_5 = {
  key: 0,
  style: {"margin-bottom":"8px"}
}
const _hoisted_6 = {
  key: 0,
  style: {"color":"red","font-size":"13px"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { style: {"margin-top":"20px","text-align":"center"} }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "dropbox" }
const _hoisted_11 = ["multiple"]
const _hoisted_12 = {
  key: 0,
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_13 = { style: {"font-size":"13px","font-weight":"400"} }
const _hoisted_14 = {
  key: 1,
  class: "dropbox-init-message"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 2,
  style: {"color":"red","font-size":"13px","margin-top":"8px"}
}
const _hoisted_17 = { key: 3 }
const _hoisted_18 = {
  key: 4,
  style: {"margin-top":"28px","margin-bottom":"28px"}
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  class: "row",
  style: {"font-weight":"bold"}
}
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { style: {"display":"flex","justify-content":"space-between","border-top":"1px solid lightgrey","padding-top":"8px","margin-top":"8px"} }
const _hoisted_24 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  class: "row",
  style: {"font-weight":"bold"}
}
const _hoisted_27 = { class: "col-6" }
const _hoisted_28 = { class: "col-2" }
const _hoisted_29 = { class: "col-2" }
const _hoisted_30 = { class: "col-2" }
const _hoisted_31 = { class: "col-6" }
const _hoisted_32 = { class: "col-2" }
const _hoisted_33 = { class: "col-2" }
const _hoisted_34 = { class: "col-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InformationOutlineIcon = _resolveComponent("InformationOutlineIcon")!
  const _component_CTooltip = _resolveComponent("CTooltip")!
  const _component_CFormInput = _resolveComponent("CFormInput")!
  const _component_LanguageSelect = _resolveComponent("LanguageSelect")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_CFormCheck = _resolveComponent("CFormCheck")!
  const _component_CButton = _resolveComponent("CButton")!
  const _component_CSpinner = _resolveComponent("CSpinner")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_CProgressBar = _resolveComponent("CProgressBar")!
  const _component_CProgress = _resolveComponent("CProgress")!
  const _component_CBadge = _resolveComponent("CBadge")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($props.isAnonymousMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_CTooltip, {
            content: _ctx.$t('email_result')
          }, {
            toggler: _withCtx(({ on }) => [
              _createElementVNode("span", _mergeProps(_toHandlers(on, true), { class: "title-input" }), [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('your_email')) + "*", 1),
                _createVNode(_component_InformationOutlineIcon, { size: 20 })
              ], 16)
            ]),
            _: 1
          }, 8, ["content"]),
          _createVNode(_component_CFormInput, {
            modelValue: $data.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.email) = $event)),
            placeholder: _ctx.$t('email'),
            class: "email-input"
          }, null, 8, ["modelValue", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CTooltip, {
      content: _ctx.$t('provide_language')
    }, {
      toggler: _withCtx(({ on }) => [
        _createElementVNode("span", _mergeProps(_toHandlers(on, true), { class: "title-input" }), [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t('audio_language')) + "*", 1),
          _createVNode(_component_InformationOutlineIcon, { size: 20 })
        ], 16)
      ]),
      _: 1
    }, 8, ["content"]),
    _createVNode(_component_LanguageSelect, {
      modelValue: $data.language,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.language) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_CTooltip, {
      content: _ctx.$t('speaker_num_reason')
    }, {
      toggler: _withCtx(({ on }) => [
        _createElementVNode("span", _mergeProps(_toHandlers(on, true), { class: "title-input" }), [
          _createElementVNode("label", null, _toDisplayString(_ctx.$t('speaker_num')), 1),
          _createVNode(_component_InformationOutlineIcon, { size: 20 })
        ], 16)
      ]),
      _: 1
    }, 8, ["content"]),
    _createVNode(_component_v_select, {
      modelValue: $data.speaker_num,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.speaker_num) = $event)),
      options: $data.speakers_array,
      class: "input",
      clearable: false
    }, {
      option: _withCtx((option) => [
        _createTextVNode(_toDisplayString(option.label == 0 ? _ctx.$t('auto_detect') : option.label), 1)
      ]),
      "selected-option": _withCtx((option) => [
        _createTextVNode(_toDisplayString(option.label == 0 ? _ctx.$t('auto_detect') : option.label), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "options"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CFormCheck, {
          button: {
            color: $data.mode === 'upload' ? 'dark' : 'light',
            shape: 'rounded-pill',
            style: 'margin-right:8px',
          },
          type: "radio",
          name: "options",
          id: "upload",
          autocomplete: "off",
          checked: $data.mode == 'upload',
          label: _ctx.$t('upload_files'),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = (_) => ($data.mode = 'upload'))
        }, null, 8, ["button", "checked", "label"]),
        _hoisted_4,
        _createVNode(_component_CFormCheck, {
          button: {
            color: $data.mode !== 'upload' ? 'dark' : 'light',
            shape: 'rounded-pill',
          },
          type: "radio",
          name: "options",
          id: "youtube",
          autocomplete: "off",
          checked: $data.mode == 'youtube',
          label: _ctx.$t('from_youtube'),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = (_) => ($data.mode = 'youtube'))
        }, null, 8, ["button", "checked", "label"])
      ]),
      ($data.mode == 'youtube')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createVNode(_component_CFormInput, {
                type: "url",
                id: "youtube_link",
                class: "youtube_link",
                modelValue: $data.youtube_link,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.youtube_link) = $event)),
                disabled: $data.is_sending_youtube,
                onChange: _cache[6] || (_cache[6] = (v) => ($data.youtube_error = '')),
                placeholder: _ctx.$t('place_youtube_link_here')
              }, null, 8, ["modelValue", "disabled", "placeholder"]),
              (!$props.isAnonymousMode)
                ? (_openBlock(), _createBlock(_component_CButton, {
                    key: 0,
                    disabled: $data.youtube_link == '' || $data.is_sending_youtube,
                    color: "info",
                    shape: "rounded-pill",
                    style: {"width":"100%","margin-top":"8px","color":"white"},
                    onClick: $options.submitYoutube
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('submit')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            ($data.youtube_error != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t($data.youtube_error)), 1))
              : _createCommentVNode("", true),
            ($data.is_sending_youtube)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_CSpinner)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("input", {
                type: "file",
                onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($options.onFileChange && $options.onFileChange(...args))),
                accept: "audio/*,video/*",
                class: "input-file",
                multiple: $props.multiple
              }, null, 40, _hoisted_11),
              ($props.isAnonymousMode && this.files.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", {
                      style: _normalizeStyle([{"font-size":"15px","font-weight":"bold","color":"dodgerblue"}, {
                color:
                  this.errorMessage == 'invalid_format' ? 'red' : 'dodgerblue',
              }])
                    }, _toDisplayString($data.files[0].file.name), 5),
                    _createElementVNode("div", _hoisted_13, _toDisplayString($options.formattedDuration($data.audioDurationSeconds) ?? ''), 1),
                    _createVNode(_component_CButton, {
                      style: {"position":"absolute","top":"12px","right":"0","z-index":"2"},
                      onClick: $options.clearFiles
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CloseIcon)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("img", {
                      src: $data.uploadIcon,
                      alt: "upload"
                    }, null, 8, _hoisted_15),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('click_or_drop_file')), 1)
                  ]))
            ])
          ])),
      ($data.errorMessage != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($data.errorMessage === 'file_size_exceeded_gb'
            ? _ctx.$t('file_size_exceeded_gb', { x: $data.maxFileSizeInGB })
            : _ctx.$t($data.errorMessage)), 1))
        : _createCommentVNode("", true),
      ($props.isAnonymousMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            ($data.anonymousProcess)
              ? (_openBlock(), _createBlock(_component_CProgress, {
                  key: 0,
                  value: $data.anonymousProcess,
                  color: "info"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CProgressBar, { style: {"width":"100%"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($data.anonymousProcess) + "% ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"]))
              : _createCommentVNode("", true),
            _createVNode(_component_CButton, {
              style: {"width":"100%","margin-top":"16px","margin-bottom":"8px"},
              shape: "rounded-pill",
              color: "primary",
              onClick: $options.submitAnonymousAudio,
              disabled: 
            $data.isUploading || $data.is_sending_youtube || $data.errorMessage.length > 0
          
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('submit')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]))
        : ($data.files.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              ($options.isMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('records')), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.files, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: file.name + index,
                        class: "row"
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", null, _toDisplayString(file.name), 1),
                            _createElementVNode("div", null, [
                              (file.status === 'uploading')
                                ? (_openBlock(), _createBlock(_component_CProgress, {
                                    key: 0,
                                    value: file.process,
                                    color: "info"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CProgressBar, { style: {"width":"100%"} }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(file.process) + "% ", 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                : (_openBlock(), _createBlock(_component_CBadge, {
                                    key: 1,
                                    color: $options.getStatusColor(file.status)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(this.getStatus(file.status)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('language')) + ": " + _toDisplayString($data.SupportedLanguages.getLanguageByValue(file.language)), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('speakers')) + ": " + _toDisplayString(file.speakers == 0 ? _ctx.$t('auto') : file.speakers), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('name')), 1),
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('language')), 1),
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('speakers')), 1),
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('status')), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.files, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: file.name + index,
                        class: "row",
                        style: {"margin-bottom":"4px"}
                      }, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(file.name), 1),
                        _createElementVNode("div", _hoisted_32, _toDisplayString($data.SupportedLanguages.getLanguageByValue(file.language)), 1),
                        _createElementVNode("div", _hoisted_33, _toDisplayString(file.speakers == 0 ? _ctx.$t('auto') : file.speakers), 1),
                        _createElementVNode("div", _hoisted_34, [
                          (file.status === 'uploading')
                            ? (_openBlock(), _createBlock(_component_CProgress, {
                                key: 0,
                                value: file.process,
                                color: "info"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CProgressBar, { style: {"width":"100%"} }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(file.process) + "% ", 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            : (_openBlock(), _createBlock(_component_CBadge, {
                                key: 1,
                                color: $options.getStatusColor(file.status)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(this.getStatus(file.status)), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"]))
                        ])
                      ]))
                    }), 128))
                  ]))
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}